import { Injectable } from '@nestjs/common';
import {UserService} from '../user/user.service';
import {JwtService} from '@nestjs/jwt';
import {JwtPayload} from './jwt.payload';
import {bGroupSearchDto, OtpDto,  SetPinDto, SignUpDto, UserDto, UserIdDto, UserRoleDto, userSearchDto, VerifyOtpDto} from '../user/dto/user.dto';
import {CreateUserDto,LoginUserDto} from '../user/dto/user.dto';
import {AllUserStatus, LoginStatus, OtpStatus, RegistrationStatus, searchResponseModel, UserStatus, UserStatusWiseResponseModel} from '../user/dto/registraton.dto';
import { errorHandler } from '@gtpl/shared-utils/error-messages';

@Injectable()
export class AuthService {
  constructor(private readonly userService: UserService, private readonly jwtService: JwtService,  ) {}
  async validateUser(payload: JwtPayload): Promise<UserDto> {
    console.log('payl auth',payload);
    const user = await this.userService.findByPayload(payload);    
    if (!user) {
      throw 'new HttpException(Invalid token, HttpStatus.UNAUTHORIZED)';    
    }    
    return user;  
  } 

  async register(queryParams,userDto: CreateUserDto,profilePic,memberPic): Promise<RegistrationStatus> {
    try {
      return await this.userService.create(queryParams,userDto,profilePic,memberPic);
    } catch (error) {
      return errorHandler(RegistrationStatus, error);  
    }
  }

  async signup(queryParams,signupDto:SignUpDto,memberImg):Promise<LoginStatus> {
    try {
      return await this.userService.signup(queryParams,signupDto,memberImg);
    }catch (error) {
      return errorHandler(LoginStatus, error);  
    }
  }

  async verifyOtp(queryParams, verifyOtpDto:VerifyOtpDto):Promise<OtpStatus> {
    try {
      return await this.userService.verifyOtp(queryParams, verifyOtpDto);
    } catch (error) {
      return errorHandler(OtpStatus, error);
    }
  }

  async login(queryParams,loginUserDto: LoginUserDto): Promise<LoginStatus> {    
    try {
      return await this.userService.findByLogin(queryParams,loginUserDto);  
    } catch(error){
      return errorHandler(LoginStatus,error);
    }
  }

  async setPin(queryParams, setPinDto:SetPinDto, request:Request): Promise<UserStatus> {
    try {
      return await this.userService.setPin(queryParams, setPinDto, request);
    } catch(error) {
      return errorHandler(UserStatus, error);
    }
  }

  async resendOtp(queryParams,otpDto:OtpDto):Promise<UserStatus> {
    try {
      return await this.userService.resendOtp(queryParams,otpDto);
    } catch (error) {
      return errorHandler(UserStatus, error);
    }
  }

  async forgotPassword(queryParams,otpDto:OtpDto):Promise<LoginStatus> {
    try {
      return await this.userService.forgotPassword(queryParams,otpDto);
    }catch (error) {
      return errorHandler(LoginStatus, error);  
    }
  }

  async deleteUser(queryParams, userIdDto:UserIdDto, request:Request):Promise<LoginStatus> {
    try {
      return await this.userService.deleteUser(queryParams, userIdDto, request);
    } catch (error){
      return errorHandler(LoginStatus, error);
    } 
  }

  async changeUserRole(queryParams, userRoleDto:UserRoleDto, request):Promise<LoginStatus> {
    try {
      return await this.userService.changeUserRole(queryParams, userRoleDto, request);
    } catch (error){
      return errorHandler(LoginStatus, error);
    }
  }

  async getAllUsers(queryParams):Promise<AllUserStatus>{
    try {
      return await this.userService.getAllUsers(queryParams);
    } catch (error) {
      return errorHandler(AllUserStatus,error);
    }
  }

  async SetPintoBulk(queryParams):Promise<AllUserStatus>{
    try {
      return await this.userService.SetPintoBulk(queryParams);
    } catch (error) {
      return errorHandler(AllUserStatus,error);
    }
  }
  
  async getActiveUsersCount(queryParams):Promise<UserStatusWiseResponseModel>{
    try {
      return await this.userService.getActiveUsersCount(queryParams);
    } catch (error) {
      return errorHandler(UserStatusWiseResponseModel,error);
    }
  }

  async getSearchUser(queryParams,userSearchDto:userSearchDto,request:Request):Promise<searchResponseModel> {
    try {
      return await this.userService.getSearchUser(queryParams,userSearchDto);
    } catch (error) {
      return errorHandler(searchResponseModel,error);
    }
  }

  async getDonorslist(queryParams,request:Request):Promise<searchResponseModel> {
    try {
      return await this.userService.getDonorslist(queryParams);
    } catch (error) {
      return errorHandler(searchResponseModel,error);
    }
  }
}
